import { Component } from '@angular/core';

@Component({
    selector: 'chevron-next-svg',
    templateUrl: './chevron-next.component.svg',
})
export class ChevronNextComponent { }
